module.exports = __webpack_public_path__ + "static/media/BM 02.e02979a7.png";